var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b-card',{staticClass:"mt-3"},[_c('b-row',[_c('b-col',{attrs:{"md":"6","offset-md":"3"}},[_c('resource-form',{on:{"submit":_vm.submit}})],1)],1)],1)],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Add Barber")])])])
}]

export { render, staticRenderFns }